module.exports = __webpack_public_path__ + "img/youtube-music.9a120b1a.svg";